import React from "react";
import { withRouter, useLocation } from "react-router-dom";

import A from "../common/A";
import Popup from "../common/Popup";
import URL from "../../constant/URL";
import TYPE from "../../constant/TYPE";
import PROP from '../../constant/PROP';
import PopupTrigger from "../common/PopupTrigger";
import useAsideState from "../../hooks/useAsideState";
import { useLearningHistory, useUserInfo } from "../../hooks";
import DevelopChannelSelectbox from "../common/DevelopChannelSelectbox";
import { useSelector } from "react-redux";

const Aside = withRouter((props) => {
  const location = useLocation();
  const { info } = useUserInfo();
  const { aSideState, setAsideState } = useAsideState();
  const { learningHistoryInfo } = useLearningHistory();
  
  const [menuFlag, setMenuFlag] = React.useState(false);
  const [modalFlag, setModalFlag] = React.useState(false);

  const deviceInfo = useSelector(state => state.deviceInfo);
  
  const changeMenuFlag = () => {
    setMenuFlag(aSideState.menu);
  };

  const closeMenu = () => {
    setAsideState({menu : false});
  };

  const movePage = (e, pathname) => {
    if (!pathname) return;
    e.stopPropagation();
    closeMenu();

    let tab = '';
    const { emailCertYn } = info;

    if(pathname === '/'){
      localStorage.setItem('learning.id', '');
      tab = 'home';
    }else if(pathname === URL.INTRODUCTION){
      tab = 'intro';
    }else if(pathname === URL.TOPIC_LEARNING){
      localStorage.setItem('learning.id', TYPE.LEARNING.TOPIC);
      tab = 'topic';
      pathname = URL.TOPIC_LEARNING;
    }else if(pathname === URL.COURSE_LEARNING.LIST){
      // let diagnosisMemberCheck = localStorage.getItem('ai.diagnosis.member.check'); //학습회원여부 차후 단돈app개발시 사용
      if(learningHistoryInfo.isCompleteAIDiagnosis === 'N'){
        setModalFlag(true);
        return;
      }else{
        setAsideState({tab : 'course'});
        localStorage.setItem('learning.id', TYPE.LEARNING.COURSE);
        if(learningHistoryInfo.isCheckAIDiagnosisResult === 'Y'){
          pathname =  URL.COURSE_LEARNING.LIST;
        }else{
          pathname =  URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT;
        }
      }
    } else if (pathname === URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION) {
      if (learningHistoryInfo.isCompleteAIDiagnosis === 'Y') {
        pathname = URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.RESULT;
      }
    } else if (pathname === URL.ACCOUNT.APP_ID_SIGN) {
      if (emailCertYn === 'Y') {
        pathname = URL.ACCOUNT.APP_ID_SIGN_SUCCESS
      }
    }
    setAsideState({tab});
    props.history.push({pathname});
  };

  const moveGuide = () => {
    localStorage.setItem('learning.id', TYPE.LEARNING.COURSE);
    setAsideState({tab : 'course'});
    closeMenu();
    props.history.push({ pathname: URL.COURSE_LEARNING.AI_DIAGNOSIS_TEST.AI_PREDICTION,});
  };

  const menu = () => {

    return(
      <div className="lp-wrap">
        <div className="lp-container gnb-menu gm">
          <button className="btn-close-gnbmenu" onClick={closeMenu}>메뉴 닫기</button>
          {
            (deviceInfo.type === TYPE.DEVICE.PC && process.env.REACT_APP_ENV !== 'production') && (
              <DevelopChannelSelectbox />
            )
          }
          <div className="gnb-list">
            <ul>
              {
                PROP.ASIDE_MEMU[info.entryType].MAIN.map((item, index) => (
                  <li key={index}>
                    <A
                      className={location.pathname.indexOf(item.path) > -1  ? 'here' : ''}
                      onClick={(e) => movePage(e, item.path)}
                    >
                      {item.title}
                    </A>
                  </li>
                ))
              }
            </ul>
          </div>
          <div className="gnb-list small">
            <ul>
            {
                PROP.ASIDE_MEMU[info.entryType].SUB.map((item, index) => (
                  <li key={index}>
                    <A
                      onClick={(e) => movePage(e, item.path)}
                    >
                      {item.title}
                    </A>
                  </li>
                ))
              }
            </ul>
          </div>
        </div>
      </div>
    )
  };

  const renderModal = () => {
    let div;

    if(modalFlag){
      div =  <PopupTrigger onClose={()=> {
        setModalFlag(false);
      }}
      >
        <Popup buttonLabel={ [ '확인', '취소'] } onConfirm={(e)=>moveGuide()}>
          <p className="lc-alert_txt m-fw-normal">
            AI 진단테스트 후<br/>이용해 주세요.
          </p>
        </Popup>
      </PopupTrigger>;
    }else{
      div = '';
    }
    return div;
  };

  // const getLearningInfo = () => {
  //
  //   if(localStorage.getItem('user.id') && localStorage.getItem('learner.id')){
  //     Data.load({
  //       url: `${Url.API.MEMBERS.LOG}/${localStorage.getItem('user.id')}/learners/${localStorage.getItem('learner.id')}`,
  //       success: (res) => {
  //         // if(res.dgnsEndDt === null || res.dgnsEndDt === '' || res.dgnsEndDt === undefined){
  //         //   setTestFlag(false);
  //         // }else{
  //         //   setTestFlag(true);
  //         // }
  //       }
  //     });
  //   }
  // };

  // React.useEffect(getLearningInfo, [aSideState.menu]);
  React.useEffect(changeMenuFlag, [aSideState.menu]);

  return (
    <>
    {menuFlag && menu()}
    {modalFlag && renderModal()}
    </>
  );

});

export default Aside;
